module.exports = __webpack_public_path__ + "img/btn-cadillac@1x.c62f2a06.png";